import { formatMoney } from '../../../../utils';

export const currencyFormatter = ({ field, withDecimals = false, upto }) => `$${formatMoney(field.value, { withDecimals, upto })}`;

export const PercentageFormatter = (field) => {
  return field.value ? Number(field.value / 100).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2 }) : 'N/A';
};
